import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { State } from '~/Reducers'
import { fetchClan } from "./ActionClanProfile"

export let PromoSlider = null

export const NAVIGATE_TO_SLIDE = 'NAVIGATE_TO_SLIDE'
export const NavigateToSlide = (index: number, ignore?: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  if (PromoSlider) {
    PromoSlider.slickGoTo(index)
  }
  dispatch({
    type: NAVIGATE_TO_SLIDE,
    payload: {
      index: index
    }
  })
}

export const SET_SLIDER_REF = 'SET_SLIDER_REF'
export const SetSliderRef = (ref: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  if (ref) {
    PromoSlider = ref
  }
  dispatch({
    type: SET_SLIDER_REF
  })
}

export const GET_PROMO_DATA = 'GET_PROMO_DATA'
export const GetPromoData = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState()
  if (state.currentAccount && state.currentAccount.clanId) {
    dispatch(fetchClan(state.currentAccount.clanId))
  }

  dispatch({
    type: GET_PROMO_DATA
  })
}